import { render, staticRenderFns } from "./SettingsCountriesRestriction.vue?vue&type=template&id=c93da5f8&"
import script from "./SettingsCountriesRestriction.vue?vue&type=script&lang=js&"
export * from "./SettingsCountriesRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports